import script from "./GroupsTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsTabs.vue?vue&type=script&setup=true&lang=js"

import "./GroupsTabs.vue?vue&type=style&index=0&id=3d6af5f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6af5f4"]])

export default __exports__